export const WalletIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M16 8.00032V4.50097C16 3.66923 16 3.25336 15.8248 2.99779C15.6717 2.7745 15.4346 2.62281 15.1678 2.5774C14.8623 2.52542 14.4847 2.69969 13.7295 3.04824L4.85901 7.14231C4.18551 7.45316 3.84875 7.60858 3.60211 7.84963C3.38406 8.06273 3.21762 8.32287 3.1155 8.61015C3 8.9351 3 9.306 3 10.0478V15.0003M16.5 14.5003H16.51M3 11.2003L3 17.8003C3 18.9204 3 19.4805 3.21799 19.9083C3.40973 20.2846 3.71569 20.5906 4.09202 20.7823C4.51984 21.0003 5.07989 21.0003 6.2 21.0003H17.8C18.9201 21.0003 19.4802 21.0003 19.908 20.7823C20.2843 20.5906 20.5903 20.2846 20.782 19.9083C21 19.4805 21 18.9204 21 17.8003V11.2003C21 10.0802 21 9.52016 20.782 9.09234C20.5903 8.71601 20.2843 8.41005 19.908 8.2183C19.4802 8.00032 18.9201 8.00032 17.8 8.00032L6.2 8.00032C5.0799 8.00032 4.51984 8.00032 4.09202 8.2183C3.7157 8.41005 3.40973 8.71601 3.21799 9.09234C3 9.52016 3 10.0802 3 11.2003ZM17 14.5003C17 14.7765 16.7761 15.0003 16.5 15.0003C16.2239 15.0003 16 14.7765 16 14.5003C16 14.2242 16.2239 14.0003 16.5 14.0003C16.7761 14.0003 17 14.2242 17 14.5003Z" />
    </svg>
  );
};
